import DeliveryMethods from '../mixins/delivery-methods'
export default {
  methods: {
    /**
    * コピーライトの表示をドメイン毎に切り替える
    */
    getCopyright () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'JMEC All Rights Reserved.'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'C-edge All Rights Reserved.'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'Contact YM All Rights Reserved.'
      }
      return ''
    },
    /**
    * ログイン画面の戻るボタンの文言をドメイン毎に切り替える
    */
    getLoginViewBackButtonWording () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'JMECサイトへ'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'C-edgeへ'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'Contact YMへ'
      }
      return ''
    },
    /**
     * ログイン画面の戻るボタンのリンクをドメイン毎に切り替える
     * @returns
     */
    getLoginViewBackButtonLink () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'https://www.jmec.co.jp/'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'https://cedge-inc.com/'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'https://contactym-inc.com/'
      }
      return ''
    },
    /**
     * FAQ画面のリンク文言をドメイン毎に切り替える
     */
    getFAQViewInquiryLinkWording () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'https://www.jmec.co.jp/contact/contact01/'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'https://cedge-inc.com/contacts/'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'https://contactym-inc.com/contacts/'
      }
      return ''
    },
    /**
     * 再登録のメール失敗時のお問い合わせフォームのリンクを返却する
     * @returns メール失敗時のお問い合わせフォームのリンク
     */
    getInquiryLinkOfSendMailFailed () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'https://www.jmec.co.jp/contact/contact01/'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'https://cedge-inc.com/contacts/'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'https://contactym-inc.com/contacts/'
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/WordUtil.js